
import { defineComponent, PropType } from "vue";
import { Aspect } from "@/types";
import { Icon, ModalWindow } from "@/shared/ui";
import { EditAspect } from "@/features";

export default defineComponent({
	name: "Aspect",
	components: { EditAspect, Icon, ModalWindow },
	emits: ["update", "remove"],
	props: {
		aspect: {
			type: Object as PropType<Aspect>,
			required: true,
		},
	},
	data() {
		return {
			editMode: false,
		};
	},
	computed: {
		diceIcon() {
			return this.aspect.type === "concept"
				? "DicePositive"
				: this.aspect.type === "problem"
				? "DiceNegative"
				: "DiceNeutral";
		},
	},
	methods: {
		remove() {
			this.$emit("remove");
		},
		update(newAspect: Aspect) {
			this.$emit("update", newAspect);
		},
	},
});
